/* eslint-disable no-underscore-dangle,@typescript-eslint/no-unused-vars */

xplenty.directive('crossJoinEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./cross-join-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        function ($scope) {
          $scope.onValidityChange(true);

          const components = [];
          // true for flagging the method to give back schemas by `order` property
          $scope.parentSchemas = $scope._default.getParentComponentsSchemas(true);

          _.each($scope.parentSchemas, function (parentSchema) {
            if (parentSchema && parentSchema.id) {
              const component = $scope._default.package.getComponentById(parentSchema.id);
              components.push(component);
            } else {
              components.push(null);
            }
          });

          $scope.components = components;
        },
      ],
    };
  },
]);
